import type { Story } from '@/store/story-types'

export const LINK_IN_BIO_STORE_STORY: Story = {
  id: 'link-in-bio-store-1',
  name: 'Link-in-Bio Store',
  narrative: 'A bio page with integrated mini store and tip jar, letting creators share links, sell products, and collect tips — inspired by Beacons and Campsite.',
  goals: ['Showcase creator identity', 'Share curated links', 'Sell digital/physical products', 'Accept tips and support'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-main', title: 'Mia Crafts', order: 0, status: 'draft', elementCount: 4, linkedPageId: 'main', description: 'Single-page bio with header, links, mini store, and footer',
      blockRef: { category: 'bio', blockId: 'bio-header' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Bio',
      description: 'Visitor sees the creator bio header',
      steps: [
        { type: 'given', text: 'the visitor opens the bio page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the creator avatar, name, and bio description are visible', linkedPageId: 'main' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Browse Links',
      description: 'Visitor browses the curated link list',
      steps: [
        { type: 'given', text: 'the visitor is on the bio page' },
        { type: 'when', text: 'they scroll to the links section' },
        { type: 'then', text: 'a list of clickable links with labels and icons is displayed', linkedPageId: 'main' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Browse Products',
      description: 'Visitor browses products in the mini store',
      steps: [
        { type: 'given', text: 'the visitor is on the bio page' },
        { type: 'when', text: 'they scroll to the mini store section' },
        { type: 'then', text: 'product cards with images, titles, and prices are shown', linkedPageId: 'main' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Purchase Product',
      description: 'Visitor adds a product to cart and purchases',
      steps: [
        { type: 'given', text: 'the visitor sees a product they want' },
        { type: 'when', text: 'they tap the Add to Cart button' },
        { type: 'then', text: 'the product is added to the cart', linkedFlowId: 'addToCart' },
        { type: 'and', text: 'the cart item count updates' },
      ],
    },
  ],
}
